import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from '@nosto/preact'
import { useState } from 'preact/hooks'
import { formatCurrency } from "../helpers"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [ active, setActive ] = useState(isSelected)

    return (
        <details class="facets__disclosure-vertical js-filter">
            <summary 
                class="facets__summary facets__text focus-offset" 
                aria-label={`${facet.name} (${isSelected ? "1" : "0"} selectionado)`}
                aria-expanded={active}
                aria-controls={`ns-serp-${facet.id}-facet`}
                role="button"
                onClick={() => { setActive(prevActive => !prevActive)}}
            >
                <div>
                    <span>
                        {facet.name}
                        <span class="facets__selected no-js-hidden hidden">
                            ({isSelected ? "1" : "0"})
                        </span>
                    </span>
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
                    </svg>
                </div>
            </summary>

            <div 
                id={`ns-serp-${facet.id}-facet`}
                class="facets__display-vertical"
            >
                <div class="facets__header-vertical">
                    <span class="facets__selected">El precio más alto es {max}</span>
                </div>

                <div class="facets__price">
                    <span class="field-currency">$</span>
                    <div class="field">
                        <input
                            type="number"
                            class="field__input"
                            id={`ns-${facet.id}-min`}
                            placeholder={min}
                            // value={range[0]}
                            min={min}
                            max={max}
                            onChange={(e) => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                        />
                        <label for={`ns-${facet.id}-min`} class="field__label">
                            De
                        </label>
                    </div>
                    <div class="field">
                        <input
                            type="number"
                            class="field__input"
                            placeholder={max}
                            id={`ns-${facet.id}-max`}
                            // value={range[1]}
                            min={min}
                            max={max}
                            onChange={(e) => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                            }}
                        />
                        <label for={`ns-${facet.id}-max`} class="field__label">
                            Para
                        </label>
                    </div>
                </div>
                <div class="ns-d-none">
                    <RangeSlider id={facet.id} />
                </div>
            </div>
        </details>

    )
}
